/* src/app/shared/ui-kit/pa-editor/pa-editor.component.scss */
.pa-editor {
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
}
@media (max-width: 1199px) {
  :host ::ng-deep .ql-toolbar.ql-snow .ql-formats {
    margin-inline-end: 0px !important;
  }
}
:host ::ng-deep .ql-snow .ql-picker.ql-header {
  width: 120px !important;
}
:host ::ng-deep .ql-editor ol {
  padding-left: 1.25rem;
}
:host ::ng-deep .ql-editor ol li[data-list=bullet] {
  list-style-type: disc;
  padding-left: 0.2rem;
}
:host ::ng-deep .ql-editor ol li[data-list=ordered] {
  list-style-type: decimal;
  padding-left: 0.2rem;
}
:host ::ng-deep .ql-editor li[data-list]::before {
  content: none !important;
}
:host ::ng-deep .ql-editor li[data-list] > .ql-ui {
  display: none;
}
/*# sourceMappingURL=pa-editor.component.css.map */
